import { Routes } from '@angular/router';
import { authPagesGuard } from '@core/guards/auth/auth-pages.guard';

export const AUTH_SLUGS = {
    login: 'login',
    signup: 'signup',
    forgotPassword: 'forgot-password',
    resetPassword: 'reset-password',
    choosePassword: 'welcome',
    verify: 'verify',
    onboarding: 'onboarding',
    invitation: 'invitation',
    verification: 'verification',
} as const;
export type AuthSlugs = (typeof AUTH_SLUGS)[keyof typeof AUTH_SLUGS];

export const AUTH_ROUTES: Routes = [
    {
        path: AUTH_SLUGS.invitation,
        title: 'Invitation',
        canActivate: [authPagesGuard],
        loadComponent: () =>
            import('@features/auth/invitation/signup-invitation/signup-invitation.component').then(
                m => m.SignupInvitationComponent
            ),
    },
    {
        path: `${AUTH_SLUGS.invitation}/waiting`,
        title: 'Waiting for Confirmation',
        canActivate: [authPagesGuard],
        loadComponent: () =>
            import(
                '@features/auth/invitation/invitation-waiting/invitation-waiting.component'
            ).then(m => m.InvitationWaitingComponent),
    },
    {
        path: `${AUTH_SLUGS.verification}/:token`,
        title: 'Verify Invitation',
        canActivate: [authPagesGuard],
        loadComponent: () =>
            import(
                '@features/auth/invitation/invitation-verification/invitation-verification.component'
            ).then(m => m.InvitationVerificationComponent),
    },
    {
        path: AUTH_SLUGS.login,
        title: 'Login',
        canActivate: [authPagesGuard],
        loadComponent: () =>
            import('@features/auth/login/login.component').then(m => m.LoginComponent),
    },
    {
        path: AUTH_SLUGS.resetPassword + '/:token',
        title: 'Reset password',
        pathMatch: 'full',
        loadComponent: () =>
            import('@features/auth/reset-password/reset-password.component').then(
                m => m.ResetPasswordComponent
            ),
    },
    {
        path: AUTH_SLUGS.choosePassword + '/:token',
        title: 'Welcome',
        pathMatch: 'full',
        loadComponent: () =>
            import('@features/auth/choose-password/choose-password.component').then(
                m => m.ChoosePasswordComponent
            ),
    },
    {
        path: AUTH_SLUGS.verify,
        title: 'Verify',
        canActivate: [authPagesGuard],
        loadComponent: () =>
            import('@features/auth/verification-code/verification-code.component').then(
                m => m.VerificationCodeComponent
            ),
    },

    { path: '**', redirectTo: AUTH_SLUGS.login },
];
